<template>
  <div class="">
    <div class="top-img">
      <img src="../assets/awards/banner.png" alt="" />
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部奖项" name="index">
          <div class="awards">
            <!-- <p class="awards-title">CPSE安博会颁奖</p> -->
            <div class="awards-molude">
              <ul>
                <li :plain="true" @click="open3">
                 <!-- <router-link
                :to="{ name: 'awards', params: { imgId: 2, cate_id: 108 } }"
              > -->
				<a href="http://spe.cps.com.cn/2021bdpx/gxj.html" target="_blank">
                  <div class="awards-a">
                    <img src="../assets/awards/img2.png" />
                    <p class="awards-a-ti">2021年第六届全球安防贡献奖</p>
                  </div>
				  </a>
                 <!-- </router-link> -->
                </li>
                <li>
                 <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 0, cate_id: 106 } }"
                  > -->
				  <a href="http://spe.cps.com.cn/2021bdpx/jdj.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img0.png" />
                      <p class="awards-a-ti">2021年CPSE安博会金鼎奖</p>
                    </div>
					</a>
                 <!-- </router-link> -->
                </li>
                <li>
                  <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 1, cate_id: 107 } }"
                  > -->
				  <a href="http://spe.cps.com.cn/2021bdpx/tjpp.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img1.png" />
                      <p class="awards-a-ti">
                        2021年第十届中国智慧城市建设推荐品牌
                      </p>
                    </div>
					</a>
                  <!-- </router-link> -->
                </li>
              </ul>
            </div>
          </div>
          <div class="awards">
            <!-- <p class="awards-title">CPS团拜会颁奖</p> -->
            <div class="awards-molude">
              <ul>
                <li>
<!--                  <router-link
                    :to="{
                      name: 'special',
                      params: { imgId: 5, cate_id: 110 },
                    }"
                  > -->
				  <a  href="http://spe.cps.com.cn/2021bdpx/10yxlpp.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img5.png" />
                      <p class="awards-a-ti">
                        2021年第七届中国安防十大影响力品牌
                      </p>
                    </div>
					</a>
                  <!-- </router-link> -->
                </li>
                <li>
                  <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 3, cate_id: 109 } }"
                  > -->
				  <a href="http://spe.cps.com.cn/2021bdpx/10dxy.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img3.png" />
                     <!-- <p class="awards-a-ti">2021中国安防十大创新产品</p> -->
					  <p class="awards-a-ti">2021十大新锐产品</p>
                    </div>
					</a>
                  <!-- </router-link> -->
                </li>
<!--               <li>
                  <router-link
                    :to="{ name: 'awards', params: { imgId: 4, cate_id: 109 } }"
                  >
                    <div class="awards-a">
                      <img src="../assets/awards/img4.png" />
                      <p class="awards-a-ti">2021年安防新基建创新品牌</p>
                    </div>
                  </router-link>
                </li> -->
				<li>
				  <!-- <router-link
				    :to="{ name: 'awards', params: { imgId: 6, cate_id: 122 } }"
				  > -->
				   <a href="http://csiec2021.cps.com.cn/index.php?s=/index/zx_second.html" target="_blank">
				    <div class="awards-a">
				      <img src="../assets/awards/img6.png" width="373px" height="" />
				      <p class="awards-a-ti">2021荣耀安防奖</p>
				    </div>
					</a>
				  <!-- </router-link> -->
				</li>
              </ul>
            </div>
          </div>
          <div class="awards">
            <!-- <p class="awards-title">赋能大会颁奖</p> -->
            <div class="awards-molude">
              <ul>
<!--               <li>
                  <router-link
                    :to="{ name: 'awards', params: { imgId: 6, cate_id: 109 } }"
                  >
                    <div class="awards-a">
                      <img src="../assets/awards/img6.png" width="373px" height="" />
                      <p class="awards-a-ti">2021荣耀安防奖</p>
                    </div>
                  </router-link>
                </li> -->
                <li>
                  <a
                    href="http://cpspew.com/special/2020jy/index.html"
                  >
                    <div class="awards-a">
                      <img style="width:373px;height:178px;" src="../assets/awards/img7.png" />
                      <p class="awards-a-ti">第三届（2020-2021年度）警用装备科技创新大奖</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          </el-tab-pane>
        <el-tab-pane label="CPSE安博会颁奖" name="first">
          <div class="awards">
            <!-- <p class="awards-title">CPSE安博会颁奖</p> -->
            <div class="awards-molude">
              <ul>
                <li :plain="true" @click="open3">
                 <!-- <router-link
                :to="{ name: 'awards', params: { imgId: 2, cate_id: 108 } }"
              > -->
			  <a href="http://spe.cps.com.cn/2021bdpx/gxj.html" target="_blank">
                  <div class="awards-a">
                    <img src="../assets/awards/img2.png" />
                    <p class="awards-a-ti">2021年第六届全球安防贡献奖</p>
                  </div>
				  </a>
                  <!-- </router-link> -->
                </li>
                <li>
                  <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 0, cate_id: 106 } }"
                  > -->
				  <a href="http://spe.cps.com.cn/2021bdpx/jdj.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img0.png" />
                      <p class="awards-a-ti">2021年CPSE安博会金鼎奖</p>
                    </div>
					</a>
                  <!-- </router-link> -->
                </li>
                <li>
                 <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 1, cate_id: 107 } }"
                  > -->
				  <a href="http://spe.cps.com.cn/2021bdpx/tjpp.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img1.png" />
                      <p class="awards-a-ti">
                        2021年第十届中国智慧城市建设推荐品牌
                      </p>
                    </div>
					</a>
                 <!-- </router-link> -->
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="CPS团拜会颁奖" name="second">
          <div class="awards">
            <!-- <p class="awards-title">CPS团拜会颁奖</p> -->
            <div class="awards-molude">
              <ul>
                <li>
                  <!-- <router-link
                    :to="{
                      name: 'special',
                      params: { imgId: 5, cate_id: 110 },
                    }"
                  > -->
				  <a  href="http://spe.cps.com.cn/2021bdpx/10yxlpp.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img5.png" />
                      <p class="awards-a-ti">
                        2021年第七届中国安防十大影响力品牌
                      </p>
                    </div>
					</a>
                  <!-- </router-link> -->
                </li>
                <li>
                  <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 3, cate_id: 109 } }"
                  > -->
				  <a href="http://spe.cps.com.cn/2021bdpx/10dxy.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img3.png" />
                      <!-- <p class="awards-a-ti">2021中国安防十大创新产品</p> -->
					  <p class="awards-a-ti">2021十大新锐产品</p>
                    </div>
					</a>
                  <!-- </router-link> -->
                </li>
                <li>
                  <a
                    href="http://cpspew.com/special/2020jy/index.html"
                  >
                    <div class="awards-a">
                      <img style="width:373px;height:178px;" src="../assets/awards/img7.png" />
                      <p class="awards-a-ti">第三届（2020-2021年度）警用装备科技创新大奖</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="赋能大会颁奖" name="third">
          <div class="awards">
            <!-- <p class="awards-title">赋能大会颁奖</p> -->
            <div class="awards-molude">
              <ul>
                <li>
                 <!-- <router-link
                    :to="{ name: 'awards', params: { imgId: 6, cate_id: 122 } }"
                  > -->
				  <a href="http://csiec2021.cps.com.cn/index.php?s=/index/zx_second.html" target="_blank">
                    <div class="awards-a">
                      <img src="../assets/awards/img6.png" width="373px" height="" />
                      <p class="awards-a-ti">2021荣耀安防奖</p>
                    </div>
					</a>
                 <!-- </router-link> -->
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <tail></tail>
  </div>
</template>

<script>
import top from "./top";
import tail from "./tail";
export default {
  components: {
    top: top,
    tail: tail,
  },
  data() {
    return {
      activeName: "index",
    };
  },
  methods: {
    open3() {
      // this.$message({
      //   message: "敬请期待！",
      //   type: "warning",
      // });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
//导航栏样式
/deep/ .el-tabs__header {
  background: #fff;
  height: 48px;
}
/deep/ .el-tabs__active-bar {
  width: 300px;
}
/deep/ .el-tabs__item {
  width: 300px;
  text-align: center;
  height: 48px;
  line-height: 48px;
}
/deep/ .el-tabs__active-bar {
  height: 3px;
}
/deep/ .el-tabs__item.is-active {
  color: #df2a2a;
}
/deep/ .el-tabs__active-bar {
  background-color: #df2a2a;
  width: 300px;
  margin-left: 10px;
}
/deep/ .el-tabs__nav {
  height: 48px;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #df2a2a;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #df2a2a;
  border-color: #df2a2a;
}
/deep/.el-tabs__item:hover {
  color: #df2a2a;
}

.top-img {
  img {
    height: 400px;
    width: 100%;
  }
}
.content {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 30px;
  .awards {
    .awards-title {
      font-size: 18px;
      margin: 30px 0px 18px 0px;
      font-weight: 600;
    }
    .awards-molude {
      background-color: #fff;
      height: 210px;
      padding: 20px 8px;
      ul {
        li {
          float: left;
          display: inline-block;
          margin: 0px 10px;
          .awards-a {
            // background: #f0f0f0;
            // width: 374px;
            // height: 146px;
            text-align: center;
            padding-top: 0.1px;
            img {
              // width: 374px;
              // height: 179px;
              border-radius: 10px;
            }
            .awards-a-ti {
              font-size: 16px;
              margin-top: 5px;
              font-family: "Alibaba PuHuiTi";
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue